import { TextStyle_TextAlignment, Link_Target, PluginContainerData_Alignment, PluginContainerData_Width_Type, } from './common.enums';
export function textStyle_TextAlignmentFromJSON(object) {
    switch (object) {
        case 0:
        case 'AUTO':
            return TextStyle_TextAlignment.AUTO;
        case 1:
        case 'LEFT':
            return TextStyle_TextAlignment.LEFT;
        case 2:
        case 'RIGHT':
            return TextStyle_TextAlignment.RIGHT;
        case 3:
        case 'CENTER':
            return TextStyle_TextAlignment.CENTER;
        case 4:
        case 'JUSTIFY':
            return TextStyle_TextAlignment.JUSTIFY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TextStyle_TextAlignment.UNRECOGNIZED;
    }
}
export function textStyle_TextAlignmentToJSON(object) {
    switch (object) {
        case TextStyle_TextAlignment.AUTO:
            return 'AUTO';
        case TextStyle_TextAlignment.LEFT:
            return 'LEFT';
        case TextStyle_TextAlignment.RIGHT:
            return 'RIGHT';
        case TextStyle_TextAlignment.CENTER:
            return 'CENTER';
        case TextStyle_TextAlignment.JUSTIFY:
            return 'JUSTIFY';
        default:
            return 'UNKNOWN';
    }
}
export function link_TargetFromJSON(object) {
    switch (object) {
        case 0:
        case 'SELF':
            return Link_Target.SELF;
        case 1:
        case 'BLANK':
            return Link_Target.BLANK;
        case 2:
        case 'PARENT':
            return Link_Target.PARENT;
        case 3:
        case 'TOP':
            return Link_Target.TOP;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Link_Target.UNRECOGNIZED;
    }
}
export function link_TargetToJSON(object) {
    switch (object) {
        case Link_Target.SELF:
            return 'SELF';
        case Link_Target.BLANK:
            return 'BLANK';
        case Link_Target.PARENT:
            return 'PARENT';
        case Link_Target.TOP:
            return 'TOP';
        default:
            return 'UNKNOWN';
    }
}
export function pluginContainerData_AlignmentFromJSON(object) {
    switch (object) {
        case 0:
        case 'CENTER':
            return PluginContainerData_Alignment.CENTER;
        case 1:
        case 'LEFT':
            return PluginContainerData_Alignment.LEFT;
        case 2:
        case 'RIGHT':
            return PluginContainerData_Alignment.RIGHT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PluginContainerData_Alignment.UNRECOGNIZED;
    }
}
export function pluginContainerData_AlignmentToJSON(object) {
    switch (object) {
        case PluginContainerData_Alignment.CENTER:
            return 'CENTER';
        case PluginContainerData_Alignment.LEFT:
            return 'LEFT';
        case PluginContainerData_Alignment.RIGHT:
            return 'RIGHT';
        default:
            return 'UNKNOWN';
    }
}
export function pluginContainerData_Width_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'CONTENT':
            return PluginContainerData_Width_Type.CONTENT;
        case 1:
        case 'SMALL':
            return PluginContainerData_Width_Type.SMALL;
        case 2:
        case 'ORIGINAL':
            return PluginContainerData_Width_Type.ORIGINAL;
        case 3:
        case 'FULL_WIDTH':
            return PluginContainerData_Width_Type.FULL_WIDTH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PluginContainerData_Width_Type.UNRECOGNIZED;
    }
}
export function pluginContainerData_Width_TypeToJSON(object) {
    switch (object) {
        case PluginContainerData_Width_Type.CONTENT:
            return 'CONTENT';
        case PluginContainerData_Width_Type.SMALL:
            return 'SMALL';
        case PluginContainerData_Width_Type.ORIGINAL:
            return 'ORIGINAL';
        case PluginContainerData_Width_Type.FULL_WIDTH:
            return 'FULL_WIDTH';
        default:
            return 'UNKNOWN';
    }
}
const baseTextStyle = { textAlignment: TextStyle_TextAlignment.AUTO };
export const TextStyle = {
    fromJSON(object) {
        const message = Object.assign({}, baseTextStyle);
        message.textAlignment =
            object.textAlignment !== undefined && object.textAlignment !== null
                ? textStyle_TextAlignmentFromJSON(object.textAlignment)
                : TextStyle_TextAlignment.AUTO;
        message.lineHeight =
            object.lineHeight !== undefined && object.lineHeight !== null
                ? String(object.lineHeight)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.textAlignment !== undefined &&
            (obj.textAlignment = textStyle_TextAlignmentToJSON(message.textAlignment));
        message.lineHeight !== undefined && (obj.lineHeight = message.lineHeight);
        return obj;
    },
};
const baseLink = { target: Link_Target.SELF };
export const Link = {
    fromJSON(object) {
        const message = Object.assign({}, baseLink);
        message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
        message.anchor =
            object.anchor !== undefined && object.anchor !== null ? String(object.anchor) : undefined;
        message.target =
            object.target !== undefined && object.target !== null
                ? link_TargetFromJSON(object.target)
                : Link_Target.SELF;
        message.rel =
            object.rel !== undefined && object.rel !== null ? Link_Rel.fromJSON(object.rel) : undefined;
        message.customData =
            object.customData !== undefined && object.customData !== null
                ? String(object.customData)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.url !== undefined && (obj.url = message.url);
        message.anchor !== undefined && (obj.anchor = message.anchor);
        message.target !== undefined && (obj.target = link_TargetToJSON(message.target));
        message.rel !== undefined && (obj.rel = message.rel ? Link_Rel.toJSON(message.rel) : undefined);
        message.customData !== undefined && (obj.customData = message.customData);
        return obj;
    },
};
const baseLink_Rel = {};
export const Link_Rel = {
    fromJSON(object) {
        const message = Object.assign({}, baseLink_Rel);
        message.nofollow =
            object.nofollow !== undefined && object.nofollow !== null
                ? Boolean(object.nofollow)
                : undefined;
        message.sponsored =
            object.sponsored !== undefined && object.sponsored !== null
                ? Boolean(object.sponsored)
                : undefined;
        message.ugc = object.ugc !== undefined && object.ugc !== null ? Boolean(object.ugc) : undefined;
        message.noreferrer =
            object.noreferrer !== undefined && object.noreferrer !== null
                ? Boolean(object.noreferrer)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nofollow !== undefined && (obj.nofollow = message.nofollow);
        message.sponsored !== undefined && (obj.sponsored = message.sponsored);
        message.ugc !== undefined && (obj.ugc = message.ugc);
        message.noreferrer !== undefined && (obj.noreferrer = message.noreferrer);
        return obj;
    },
};
const basePluginContainerData = { alignment: PluginContainerData_Alignment.CENTER };
export const PluginContainerData = {
    fromJSON(object) {
        const message = Object.assign({}, basePluginContainerData);
        message.width =
            object.width !== undefined && object.width !== null
                ? PluginContainerData_Width.fromJSON(object.width)
                : undefined;
        message.alignment =
            object.alignment !== undefined && object.alignment !== null
                ? pluginContainerData_AlignmentFromJSON(object.alignment)
                : PluginContainerData_Alignment.CENTER;
        message.spoiler =
            object.spoiler !== undefined && object.spoiler !== null
                ? PluginContainerData_Spoiler.fromJSON(object.spoiler)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null
                ? PluginContainerData_Height.fromJSON(object.height)
                : undefined;
        message.textWrap =
            object.textWrap !== undefined && object.textWrap !== null
                ? Boolean(object.textWrap)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.width !== undefined &&
            (obj.width = message.width ? PluginContainerData_Width.toJSON(message.width) : undefined);
        message.alignment !== undefined &&
            (obj.alignment = pluginContainerData_AlignmentToJSON(message.alignment));
        message.spoiler !== undefined &&
            (obj.spoiler = message.spoiler
                ? PluginContainerData_Spoiler.toJSON(message.spoiler)
                : undefined);
        message.height !== undefined &&
            (obj.height = message.height ? PluginContainerData_Height.toJSON(message.height) : undefined);
        message.textWrap !== undefined && (obj.textWrap = message.textWrap);
        return obj;
    },
};
const basePluginContainerData_Spoiler = {};
export const PluginContainerData_Spoiler = {
    fromJSON(object) {
        const message = Object.assign({}, basePluginContainerData_Spoiler);
        message.enabled =
            object.enabled !== undefined && object.enabled !== null ? Boolean(object.enabled) : undefined;
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : undefined;
        message.buttonText =
            object.buttonText !== undefined && object.buttonText !== null
                ? String(object.buttonText)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.enabled !== undefined && (obj.enabled = message.enabled);
        message.description !== undefined && (obj.description = message.description);
        message.buttonText !== undefined && (obj.buttonText = message.buttonText);
        return obj;
    },
};
const basePluginContainerData_Width = {};
export const PluginContainerData_Width = {
    fromJSON(object) {
        const message = Object.assign({}, basePluginContainerData_Width);
        message.size =
            object.size !== undefined && object.size !== null
                ? pluginContainerData_Width_TypeFromJSON(object.size)
                : undefined;
        message.custom =
            object.custom !== undefined && object.custom !== null ? String(object.custom) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.size !== undefined &&
            (obj.size =
                message.size !== undefined
                    ? pluginContainerData_Width_TypeToJSON(message.size)
                    : undefined);
        message.custom !== undefined && (obj.custom = message.custom);
        return obj;
    },
};
const basePluginContainerData_Height = {};
export const PluginContainerData_Height = {
    fromJSON(object) {
        const message = Object.assign({}, basePluginContainerData_Height);
        message.custom =
            object.custom !== undefined && object.custom !== null ? String(object.custom) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.custom !== undefined && (obj.custom = message.custom);
        return obj;
    },
};
const baseFileSource = {};
export const FileSource = {
    fromJSON(object) {
        const message = Object.assign({}, baseFileSource);
        message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
        message.custom =
            object.custom !== undefined && object.custom !== null ? String(object.custom) : undefined;
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        message.private =
            object.private !== undefined && object.private !== null ? Boolean(object.private) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.url !== undefined && (obj.url = message.url);
        message.custom !== undefined && (obj.custom = message.custom);
        message.id !== undefined && (obj.id = message.id);
        message.private !== undefined && (obj.private = message.private);
        return obj;
    },
};
const baseMedia = {};
export const Media = {
    fromJSON(object) {
        const message = Object.assign({}, baseMedia);
        message.src =
            object.src !== undefined && object.src !== null ? FileSource.fromJSON(object.src) : undefined;
        message.width =
            object.width !== undefined && object.width !== null ? Number(object.width) : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? Number(object.height) : undefined;
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? Number(object.duration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.src !== undefined &&
            (obj.src = message.src ? FileSource.toJSON(message.src) : undefined);
        message.width !== undefined && (obj.width = message.width);
        message.height !== undefined && (obj.height = message.height);
        message.duration !== undefined && (obj.duration = message.duration);
        return obj;
    },
};
const basePlaybackOptions = {};
export const PlaybackOptions = {
    fromJSON(object) {
        const message = Object.assign({}, basePlaybackOptions);
        message.autoPlay =
            object.autoPlay !== undefined && object.autoPlay !== null
                ? Boolean(object.autoPlay)
                : undefined;
        message.playInLoop =
            object.playInLoop !== undefined && object.playInLoop !== null
                ? Boolean(object.playInLoop)
                : undefined;
        message.showControls =
            object.showControls !== undefined && object.showControls !== null
                ? Boolean(object.showControls)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.autoPlay !== undefined && (obj.autoPlay = message.autoPlay);
        message.playInLoop !== undefined && (obj.playInLoop = message.playInLoop);
        message.showControls !== undefined && (obj.showControls = message.showControls);
        return obj;
    },
};
const baseOembed = {};
export const Oembed = {
    fromJSON(object) {
        const message = Object.assign({}, baseOembed);
        message.type =
            object.type !== undefined && object.type !== null ? String(object.type) : undefined;
        message.width =
            object.width !== undefined && object.width !== null ? Number(object.width) : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? Number(object.height) : undefined;
        message.title =
            object.title !== undefined && object.title !== null ? String(object.title) : undefined;
        message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
        message.html =
            object.html !== undefined && object.html !== null ? String(object.html) : undefined;
        message.authorName =
            object.authorName !== undefined && object.authorName !== null
                ? String(object.authorName)
                : undefined;
        message.authorUrl =
            object.authorUrl !== undefined && object.authorUrl !== null
                ? String(object.authorUrl)
                : undefined;
        message.providerName =
            object.providerName !== undefined && object.providerName !== null
                ? String(object.providerName)
                : undefined;
        message.providerUrl =
            object.providerUrl !== undefined && object.providerUrl !== null
                ? String(object.providerUrl)
                : undefined;
        message.thumbnailUrl =
            object.thumbnailUrl !== undefined && object.thumbnailUrl !== null
                ? String(object.thumbnailUrl)
                : undefined;
        message.thumbnailWidth =
            object.thumbnailWidth !== undefined && object.thumbnailWidth !== null
                ? String(object.thumbnailWidth)
                : undefined;
        message.thumbnailHeight =
            object.thumbnailHeight !== undefined && object.thumbnailHeight !== null
                ? String(object.thumbnailHeight)
                : undefined;
        message.videoUrl =
            object.videoUrl !== undefined && object.videoUrl !== null
                ? String(object.videoUrl)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null ? String(object.version) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.width !== undefined && (obj.width = message.width);
        message.height !== undefined && (obj.height = message.height);
        message.title !== undefined && (obj.title = message.title);
        message.url !== undefined && (obj.url = message.url);
        message.html !== undefined && (obj.html = message.html);
        message.authorName !== undefined && (obj.authorName = message.authorName);
        message.authorUrl !== undefined && (obj.authorUrl = message.authorUrl);
        message.providerName !== undefined && (obj.providerName = message.providerName);
        message.providerUrl !== undefined && (obj.providerUrl = message.providerUrl);
        message.thumbnailUrl !== undefined && (obj.thumbnailUrl = message.thumbnailUrl);
        message.thumbnailWidth !== undefined && (obj.thumbnailWidth = message.thumbnailWidth);
        message.thumbnailHeight !== undefined && (obj.thumbnailHeight = message.thumbnailHeight);
        message.videoUrl !== undefined && (obj.videoUrl = message.videoUrl);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
};
//# sourceMappingURL=common.js.map